import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useController } from '../assets/components/BaseContrroler'
import { Box, Typography } from '@mui/material'





function Delivery() {

    const { baseController: { homeController } } = useController()
    const { setNavbar, setUrl } = homeController

    useEffect(() => {
        setUrl('/delivery')
        setNavbar(true)
    })

    return (
        <div className='px-2' id='about'>
            <div className="row">

                <h4 className='mb-4 fw-bold'>Karnafully International Delivery</h4>
                <div className="col-6">
                    <Typography style={{ textAlign: 'justify' }}>
                        <b> Karnafully International</b> was emerged in beginning 2010 by
                        one young entrepreneurs with a belief that a proper creative
                        execution of the brand can help it solely to create a position in the
                        market.
                        <br />
                        <br />
                        Undoubtedly advertising adds value to the product as well
                        services, but it requires an integrated plan. To <b>Karnafully
                            International</b>, an integrated communication strategy is the prime
                        concern to make the bridge between the services and consumers.
                        This the way we consider the customers' perception while
                        developing a strategy. <br /><br />
                        A proper panel of adequate people - experienced enough in brand
                        development strategy is working with us. To support the planning
                        development we are equipped with other members working in
                        market research, consumer behavioral study and brand audit.
                        Our creative team is aware of the personality of the brand; this
                        team knows it very well how a creative message and idea can be
                        communicated with different segments of consumers. And the
                        execution is done keeping the image of the brand as well as its
                        target audience. <br /><br />
                        The combination of the above is creating an unparallel room for
                        us to sustain in this competitive edge.
                    </Typography>
                    <a href="" className='explore'>EXPLORE</a>
                </div>
                <div className="col-6">
                    <img src={require('../assets/images/aboutus.jpg')} alt='karnafully' className='img-100' />
                </div>
            </div>

        </div>
    )
}

export default observer(Delivery)